import React, { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import { useEnquiry } from "../context/EnquiryContext";

export default function EnquireFab() {
  const enquiry = useEnquiry();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - doc.clientHeight;
      const pct = scrollable > 0 ? doc.scrollTop / scrollable : 0;
      setShow(pct >= 0.3);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!enquiry) return null;

  return (
    <button
      onClick={enquiry.openEnquiry}
      aria-label="Enquire Now"
      data-testid="enquire-fab"
      className={`fixed right-0 top-1/2 -translate-y-1/2 z-40 origin-right transition-all duration-300 ${
        show ? "opacity-100 translate-x-0" : "opacity-0 translate-x-full pointer-events-none"
      }`}
    >
      <span className="flex items-center gap-2 rounded-l-2xl bg-cta-500 hover:bg-cta-600 text-white pl-4 pr-3 py-4 shadow-[0_10px_30px_-8px_rgba(31,56,53,0.5)] [writing-mode:vertical-rl] rotate-180 font-semibold tracking-wide uppercase text-sm">
        <CalendarClock className="h-4 w-4 rotate-90" />
        Enquire Now
      </span>
    </button>
  );
}
